import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CardInterface, Student, ExExercise, Answer } from '@df/interfaces';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PupilService } from '@app/student/services/pupil.service';
import { GENDER, MAIN_DOMAIN } from '@app/app.constants';
import { CardSettings } from '@df/models';

@Component({
    selector: 'app-result-modal',
    templateUrl: './result-modal.component.html',
    styleUrls: ['./result-modal.component.scss']
})
export class ResultModalComponent implements OnInit, OnDestroy {
    @Input() modalRef;
    @Input() card: CardInterface;
    @Input() correctExercises;
    @Input() answers: Answer[];
    @Input() studentId: number;
    @Input() cardSettings: CardSettings;
    @Input() hasKairosBonus: boolean;
    @Input() exExerciseResult: boolean;
    @Input() isExExerciseActive: boolean;
    @Input() exExercise: ExExercise;
    @Output() accepted = new EventEmitter<boolean>();

    MAIN_DOMAIN = MAIN_DOMAIN;
    exercisesCount: number;
    correctExercisesCount: number;
    modal: BsModalRef;
    amount: number;
    isReward: boolean = false;
    student: Student;
    exExerciseReward = 0;

    private destroy$ = new Subject<boolean>();

    constructor(private taskService: PupilService) {}

    ngOnInit(): void {
        this.modal = this.modalRef;
        this.taskService
            .queryPupil(this.studentId)
            .pipe(takeUntil(this.destroy$))
            .subscribe((student: Student) => {
                this.student = student;
            });
        this.exercisesCount = this.card.exercises.length;
        this.correctExercisesCount = this.correctExercises.length;
        this.isReward = this.correctExercisesCount === this.exercisesCount;
        this.getAmount();
        if (this.isExExerciseActive && this.exExerciseResult) {
            this.exExerciseReward = this.exExercise.reward;
        }
    }

    private getAmount(): void {
        if (this.cardSettings) {
            if (this.isReward) {
                this.amount = this.cardSettings.reward;
                if (this.hasKairosBonus) {
                    this.amount += this.cardSettings.kairos_bonus;
                }
            } else {
                this.amount = this.cardSettings.penalty;
            }
        }
    }

    close(): void {
        this.modal.hide();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    setGender(): string {
        if (this.student && this.student.gender) {
            return this.student.gender === GENDER.MALE ? 'male' : 'female';
        } else {
            return 'male';
        }
    }

    adaptAmountSize(amount: number): string {
        if (amount >= 0 && amount <= 99) {
            return 'big';
        } else if (amount > 99 && amount <= 999) {
            return 'middle';
        } else if (amount > 999 && amount < 9999) {
            return 'small';
        }
    }

    acceptToCash(): void {
        this.accepted.emit(false);
        this.close();
    }

    acceptToAccount(): void {
        this.accepted.emit(true);
        this.close();
    }
}
